import { UnitDef, UnitConversion } from './types.js';
import { authService } from '../auth/AuthService.js';

export async function listUnits(): Promise<UnitDef[]> {
    const response = await fetch('/api/unit/');
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
}

export async function getUnit(unitId: string): Promise<UnitDef> {
    const response = await fetch(`/api/unit/${encodeURIComponent(unitId)}`);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
}

export async function createUnit(data: { singular: string; plural: string; abbreviation: string }): Promise<UnitDef> {
    const response = await fetch('/api/unit/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authService.getAuthHeaders(),
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const error = await response.json().catch(() => ({ detail: 'Failed to create unit' }));
        throw new Error(error.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
}

export async function updateUnit(id: string, data: { singular: string; plural: string; abbreviation: string }): Promise<UnitDef> {
    const response = await fetch(`/api/unit/${encodeURIComponent(id)}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...authService.getAuthHeaders(),
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const error = await response.json().catch(() => ({ detail: 'Failed to update unit' }));
        throw new Error(error.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
}

export async function deleteUnit(id: string): Promise<void> {
    const response = await fetch(`/api/unit/${encodeURIComponent(id)}`, {
        method: 'DELETE',
        headers: {
            ...authService.getAuthHeaders(),
        },
    });
    if (!response.ok) {
        const error = await response.json().catch(() => ({ detail: 'Failed to delete unit' }));
        throw new Error(error.detail || `HTTP error! status: ${response.status}`);
    }
}

export async function getUnitConversions(unitId: string): Promise<UnitConversion[]> {
    const response = await fetch(`/api/unit/${encodeURIComponent(unitId)}/conversions`);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
}

export async function addConversion(unitId: string, data: { toUnitId: string; factor: number }): Promise<UnitConversion> {
    const response = await fetch(`/api/unit/${encodeURIComponent(unitId)}/conversions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authService.getAuthHeaders(),
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const error = await response.json().catch(() => ({ detail: 'Failed to add conversion' }));
        throw new Error(error.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
}

export async function deleteConversion(unitId: string, conversionId: string): Promise<void> {
    const response = await fetch(`/api/unit/${encodeURIComponent(unitId)}/conversions/${encodeURIComponent(conversionId)}`, {
        method: 'DELETE',
        headers: {
            ...authService.getAuthHeaders(),
        },
    });
    if (!response.ok) {
        const error = await response.json().catch(() => ({ detail: 'Failed to delete conversion' }));
        throw new Error(error.detail || `HTTP error! status: ${response.status}`);
    }
}
